<div [ngClass]="{'simulation-right-container': type === 'Simulation Report', 'sl-chart-container': type !== 'Simulation Report'}">
  <div class="chart-wrapper">
    <div [id]="chartContainerId"></div>
  </div>
  <div class="chart-title">
    <span>{{ config.chartTitle }}</span>
  </div>
</div>
